import styled from 'styled-components';
import { WHITE } from '@/styles/variables.style';

export const Menu = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transform: ${({ show }) => (show ? 'translateX(0)' : 'translateX(100vw)')};
  transition: transform 200ms ease-in-out;
  width: 100%;
`;

export const BackButtonContainer = styled.div`
  align-items: center;
  display: flex;
  height: 60px;
  width: 100%;
`;

export const BackButton = styled.div`
  position: relative;
  cursor: pointer;
  height: 16px;
  width: 16px;
  color: ${({ color }) => color};

  &::after {
    content: '';
    position: absolute;
    top: 4px;
    right: 6px;
    border-bottom: 1px solid ${({ color }) => color};
    border-left: 1px solid ${({ color }) => color};
    height: 8px;
    width: 8px;
    transform: rotate(45deg);
  }
`;

export const Title = styled.h3`
  font-size: 14px;
  margin: 0;
  padding-left: 8px;
  text-transform: uppercase;
  color: #4a4a4a;

  &.footerMenu {
    color: ${WHITE};
  }
`;

export const PagesContainer = styled.div`
  height: calc(100% - 35px - 28px);
  margin-top: 28px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;

export const Pages = styled.div`
  padding-bottom: 90px;
`;

export const SectionItem = styled.div`
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
`;

export const SubCategory = styled.h5`
  color: black;
  font-size: 14px;
  margin: 0;
  text-transform: uppercase;

  &.footerMenu {
    color: ${WHITE};
  }
`;

export const PageLabel = styled.h5`
  color: #808080;
  font-size: 12px;
  margin: 0;

  &.footerMenu {
    color: ${WHITE};
  }
`;

export const contentTypeToUrl = {
  productRangeHairCare: 'range/hair-care',
  productRangeHairColor: 'range/hair-color',
  productRangeMakeUp: 'range/make-up',
  productRangeMens: 'range/mens',
  productRangePerm: 'range/perm',
  productRangeSkinBodyCare: 'range/skin-body-care',
  productRangeStyling: 'range/styling',
};

export const Locale = styled.div`
  align-items: center;
  border-radius: 2px;
  color: black;
  cursor: pointer;
  display: flex;
  padding: 10px;
  transition: background-color 100ms ease-in-out;

  &:hover {
    background-color: #eee;
  }
`;

export const SmallFlag = styled.img`
  border: 1px solid lightgrey;
  height: 24px;
  width: 32px;
`;

export const Language = styled.div`
  font-size: 11px;
  letter-spacing: 0.4px;
  margin-left: 30px;
  min-width: 80px;
`;

export const Region = Language.extend`
  flex-grow: 1;
`;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Mobile/MenuInner.style.js